import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function FullScreenImageViewer({ image, onClose }) {
    const { t: translate } = useTranslation('tasks');

    if (!image) return null;

    return createPortal(
        <div
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 9999999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            onClick={onClose}
        >
            <button
                aria-label={translate('image.closeAria')}
                style={{ position: 'absolute', top: '20px', right: '20px', background: 'transparent', border: 'none', color: 'white', cursor: 'pointer', padding: 'var(--space-2)' }}
                onClick={onClose}
            >
                <X size={24} />
            </button>
            <img
                src={image}
                alt={translate('image.expandedAlt')}
                style={{ maxWidth: '90%', maxHeight: '90%', objectFit: 'contain' }}
                onClick={(e) => e.stopPropagation()}
            />
        </div>,
        document.body
    );
}
